module.exports = __webpack_public_path__ + "img/web_3.0c71ae34.png";